export const OFFER_TYPES = [
  { key: "", value: "All Offers" },
  { key: "VERIFIED", value: "Pre-Offer Verification" },
  { key: "CREATE_OFFER", value: "Offer Creation" },
  { key: "OFFER_REVIEWED", value: "Offer Review" },
  { key: "OFFER_APPROVED", value: "Offer Approval" },
  { key: "OFFER_SHARED", value: "Share Offer" },
  { key: "OFFER_ACCEPTED", value: "Offer Status" },
  { key: "ONBOARD", value: "Onboard" },
  { key: "OFFER_REVISE", value: "Offer Revise" },
  { key: "", value: "Vendor as MSA" },
  { key: "RENEWAL", value: "Renewal" },
  { key: "EXIT", value: "Exit" },
];

export const CREATE_OFFER_ELC = "create_offer_elc";
